// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32_OW","comment":"styles_comment__3zPGr"};